import FtwUI from '@4tw/ui'
import Vue from 'vue'

export default function () {
  Vue.use(FtwUI)
}
